export default "__VITE_ASSET__7h1xYJFM__"